import { render, staticRenderFns } from "./CreateGroupSurveyDates.vue?vue&type=template&id=22f42328&scoped=true"
import script from "./CreateGroupSurveyDates.vue?vue&type=script&lang=js"
export * from "./CreateGroupSurveyDates.vue?vue&type=script&lang=js"
import style0 from "./CreateGroupSurveyDates.vue?vue&type=style&index=0&id=22f42328&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22f42328",
  null
  
)

export default component.exports